module.exports = __webpack_public_path__ + "media/images/flags/1x1/mar-b9509b8136df70da86ca01ce2d417f54.svg";